export default "__VITE_ASSET__DsOSPWiC__"